const validations = {
  emailStrict: {
    getMessage: () =>
      'Email field can only contain alphanumeric latin characters and special symbols . and _',
    validate: value => {
      // eslint-disable-next-line no-useless-escape
      const regExp = new RegExp(
        /^(([0-9\-_a-zA-Z+]+(\.[0-9\-_a-zA-Z+]+)*)|(".+"))@(([a-zA-Z\-_0-9]+\.)?([a-zA-Z0-9]+\.)[a-zA-Z]{2,})$/
      );
      const match = value.match(regExp);
      return {
        valid: match ? !!match.length : false,
      };
    },
  },
};

const dictionary = {
  custom: {
    MultipleChoice: {
      required: 'You need to choose at least one option',
    },
  },
};

export { dictionary, validations };



// WEBPACK FOOTER //
// ./src/validations.js